var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "accountant-shell" },
    [
      _c(
        "w-toolbar",
        [
          _c(
            "w-toolbar-select",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.$wf.isSmDown,
                  expression: "!$wf.isSmDown",
                },
              ],
              staticClass: "user-select",
              attrs: { items: _vm.options },
              on: {
                click: function ($event) {
                  return _vm.selectClicked($event)
                },
              },
            },
            [
              _c("div", { staticClass: "profile-wrap" }, [
                _vm.profileImgUrl
                  ? _c("span", { staticClass: "profile" }, [
                      _c("img", {
                        staticClass: "profile-img",
                        attrs: { src: _vm.profileImgUrl, alt: "Profile" },
                      }),
                    ])
                  : _vm._e(),
                _c("span", [
                  _c("span", { staticClass: "company" }, [
                    _vm._v(_vm._s(_vm.$ct("header"))),
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.wfUser.Firstname) +
                        " " +
                        _vm._s(_vm.wfUser.Lastname)
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm.$wf.isSmDown
            ? _c(
                "app-toolbar-button",
                {
                  staticClass: "drawer-btn",
                  on: {
                    click: function ($event) {
                      return _vm.toggleDrawer()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "bars" } })],
                1
              )
            : _vm._e(),
          _c("w-toolbar-text", { staticClass: "app-title" }, [
            _vm._v(" " + _vm._s(_vm.$ct("title")) + " "),
          ]),
          _c("w-spacer"),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "shell-body" },
        [
          _c(
            "w-drawer",
            {
              staticClass: "main-drawer",
              attrs: { hover: _vm.$wf.isSmDown, "swipe-open": "" },
              model: {
                value: _vm.drawer,
                callback: function ($$v) {
                  _vm.drawer = $$v
                },
                expression: "drawer",
              },
            },
            [
              _c("app-nav-item", {
                staticClass: "first-item",
                attrs: {
                  text: _vm.$ct("nav.clients"),
                  icon: "icon-briefcase",
                  to: "/portal",
                },
              }),
              _c("w-divider"),
              _c("app-nav-item", {
                attrs: {
                  text: _vm.$ct("nav.settings"),
                  icon: "icon-gear3",
                  to: "/portal/settings",
                },
              }),
              _c("app-nav-item", {
                attrs: {
                  text: _vm.$ct("nav.notifications"),
                  icon: "icon-envelope",
                  to: "/portal/notifications",
                },
              }),
              _c("app-nav-item", {
                attrs: {
                  text: _vm.$ct("nav.support"),
                  icon: "icon-lifebuoy",
                  to: "/portal/support",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "shell-content" }, [_c("router-view")], 1),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }